import { useLanguage } from '../i18n/language.js';
import { WaitlistForm } from './WaitlistForm.js';

export function WaitlistSection({
  storeUrl,
}: {
  readonly storeUrl: string;
}): React.ReactElement {
  const { copy } = useLanguage();

  return (
    <section
      data-landing-screen="4"
      className="mj-waitlist-section"
      id="waitlist"
      aria-labelledby="waitlist-heading"
    >
      <div className="mj-waitlist-panel" data-surface="landing-charcoal">
        <div className="mj-waitlist-copy">
          <p>{copy.waitlist.eyebrow}</p>
          <h2 id="waitlist-heading">{copy.waitlist.heading}</h2>
          <p>{copy.waitlist.supporting}</p>
        </div>
        <WaitlistForm defaultStoreUrl={storeUrl} embedded />
      </div>
    </section>
  );
}
